export class TagModel {
  tagId: number;
  tag: string;
  imageUrls: string[];
}
